// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3qNGZ","paramInput":"JobSimulator_paramInput__x672X","input":"JobSimulator_input__3dGZ3"};